export default () => ({
    available: null,

    setBtnState() {
        this.$refs.submitButton 
    }
});